<div *ngIf="params.data && !params.data.editable">
    {{params.data.title}}
</div>
<div *ngIf="params.data && params.data.editable">
    <textarea type="text" [(ngModel)]="params.data.title" style="width:100%;"
    placeholder="Place your text here" rows="2"></textarea>
</div>
